<template>
    <!-- <div class="text-box" v-html="headerHtml" v-on:touchstart="customTouchStart" v-on:touchend="customTouchEnd"></div> -->
    <!-- <div id="header_box" class="text-box" :v-bind:on-touchend="test"> -->
    <div class="display_flex color_gray_900" style="height: calc(100% - 1.99vmin)">
        <div class="highlight">
            <q-btn
                round
                outline
                :style="`color: ${isPenMode ? 'black' : 'lightgrey'};`"
                :onclick="
                    () => {
                        isPenMode = !isPenMode;
                    }
                "
            >
                <q-icon name="img:/assets/images/icon/icon_pen.svg" />
                <q-tooltip class="pen-tooltip tooltip__txt" anchor="center right" self="center left" v-model="penTooltip" transition-show="jump-right" transition-hide="jump-left"> 핵심어와 중심 문장의 핵심 내용에 밑줄을 그으며 읽으세요. </q-tooltip>
            </q-btn>
            <q-btn
                round
                outline
                :style="`color: ${isViewMode ? 'black' : 'lightgrey'};`"
                :onclick="
                    () => {
                        isViewMode = !isViewMode;
                        document.getSelection().removeAllRanges();
                    }
                "
            >
                <q-icon name="img:/assets/images/icon/icon_view.svg" />
            </q-btn>
        </div>
        <div class="pd_left_24 passage__content">
            <q-scroll-area ref="scrollAreaRef" visible style="height: 100%" class="passage__scroll">
                <q-chip v-if="bookNm?.indexOf('수능') > -1 || bookNm?.indexOf('교과') > -1">{{ bookNm }}</q-chip>
                <div id="header_box" class="text-box" :class="`${isViewMode ? 'highlighted' : 'highlighted-none'}`" :onTouchend="test" v-html="headerHtml"></div>
                <p v-if="headerHtml" v-scroll-fire="readEnd">&nbsp;</p>
            </q-scroll-area>
        </div>
    </div>
    <q-menu
        touch-position
        :target="menuShow"
        @before-hide="
            () => {
                menuShow = false;
            }
        "
    >
        <q-list style="min-width: 100px">
            <q-item clickable v-close-popup :onclick="deleteMark">
                <q-item-section>
                    <p class="display_flex">
                        <span style="width: 20px; height: 20px; margin-right: 6px; background-color: yellow; border-radius: 50%" />
                        <span class="highlight_del">하이라이팅 삭제</span>
                    </p>
                </q-item-section>
            </q-item>
            <q-separator />
            <div v-for="n in inputIdx" :key="n">
                <q-item clickable v-close-popup :onclick="() => highlightToAnswer(n)">
                    <q-item-section>
                        <div class="display_flex">
                            <p style="width: 20px; height: 20px; margin-right: 6px; text-align: center">
                                <q-icon name="done" color="grey" />
                            </p>
                            <p>답 입력 {{ n }}번</p>
                        </div>
                    </q-item-section>
                </q-item>
                <q-separator />
            </div>
            <!-- <q-item clickable v-close-popup :onclick="highlightToAnswer">
                <q-item-section>답 입력(2번)</q-item-section>
            </q-item> -->
        </q-list>
    </q-menu>
    <!-- <div class="text-box disableTouch" v-html="headerHtml" @mouseup="test"></div> -->
</template>

<script setup>
import { onMounted, onUnmounted, ref, defineProps, watch, isProxy, toRaw } from 'vue';
import dataToParse from '@/helpers/qbankParser/dataParse';
import { styleTags } from '@/helpers/qbankParser/styleTags';
import { useQuasar } from 'quasar';
import { GlobalStore } from '@/store';

const headerHtml = ref('');
const menuShow = ref(false);
const isPenMode = ref(true);
const isViewMode = ref(true);
const inputIdx = ref(0);
const bookNm = ref('');
const penTooltip = ref(false);
const scrollAreaRef = ref(null);
const $q = useQuasar();

const gstore = GlobalStore();
let currentMarkTarget = '';
let markId = 0;

const emit = defineEmits(['stopNoti', 'setInputAnswer', 'isChangeHeader']);

const props = defineProps({
    questionHeader: {
        default: '',
    },
    inputIdx: {
        default: 0,
    },
    bookNm: {
        default: '',
    },
    reviewHeader: {
        default: null,
    },
    tooltipMsg: {
        default: true,
    },
});

// TODO: oncontextmenu 테스트 이후 제거
// window.oncontextmenu = function (event) {
//     event.preventDefault();
//     // event.stopPropagation();
//     // return false;
// };

const readEnd = () => {
    emit('stopNoti');
};

const reviewHeaderInit = () => {
    setTimeout(() => {
        const item = document.querySelectorAll('mark');
        let maxCnt = 0;
        item.forEach((i) => {
            maxCnt = Number(i.className.replace('mark_')) > maxCnt ? Number(i.className.replace('mark_')) : maxCnt;
        });
        markId = maxCnt;
        addMarkEvent();
    }, 500);
};

watch(
    () => props.questionHeader,
    (newValue) => {
        if (newValue) {
            const questionHeader = toRaw(newValue);
            headerHtml.value = questionHeader;
            // if (props.tooltipMsg) {
            //     penTooltip.value = true;
            //     setTimeout(() => {
            //         penTooltip.value = false;
            //     }, 2000)
            // }
        }
    },
);

watch(
    () => props.reviewHeader,
    (newValue) => {
        // console.log('reviewHeader');
        // console.log(props.reviewHeader);
        const questionHeader = toRaw(newValue);
        headerHtml.value = questionHeader;
        reviewHeaderInit();
        // if (props.tooltipMsg) {
        //     penTooltip.value = true;
        //     setTimeout(() => {
        //         penTooltip.value = false;
        //     }, 2000)
        // }
    },
);

watch(
    () => props.inputIdx,
    (newValue) => {
        inputIdx.value = toRaw(newValue);
    },
);
watch(
    () => props.bookNm,
    (newValue) => {
        bookNm.value = toRaw(newValue);
    },
);

// watch(() => props.scrollUp, (newValue) => {
//     // bookNm.value = toRaw(newValue);
//     if (newValue !== 0) {
//         scrollAreaRef.value.setScrollPosition('vertical', 0, 300);
//     }
// })

onMounted(() => {
    inputIdx.value = props.inputIdx;
    let questionHeader = toRaw(props.questionHeader);
    if (props.reviewHeader) {
        questionHeader = toRaw(props.reviewHeader);
        reviewHeaderInit();
    }
    headerHtml.value = questionHeader;
    bookNm.value = toRaw(props.bookNm);

    // if (gstore?.platform === 'DESKTOP') {
    //     document.removeEventListener('touchstart', test);
    //     document.addEventListener('touchstart', test);
    // } else {
    //     document.removeEventListener('touchend', test);
    //     document.addEventListener('touchend', test);
    // }
    // document.oncontextmenu = function (e) {
    //     alert("오른쪽버튼을 이용할 수 없습니다...");
    //     return false;
    // }
    if (props.tooltipMsg) {
        penTooltip.value = true;
        setTimeout(() => {
            penTooltip.value = false;
        }, 2000);
    }
});

onUnmounted(() => {
    //
    headerHtml.value = '';
    penTooltip.value = false;
});

const addMarkEvent = () => {
    const item = document.querySelectorAll('mark');
    item.forEach((target) => {
        target.removeEventListener('click', onMarkTooltipMark);
        target.addEventListener('click', onMarkTooltipMark);
        // target.removeEventListener('touchend', onMarkTooltipMark);
        // target.addEventListener('touchend', onMarkTooltipMark)
    });
};

const onMarkTooltipMark = (v) => {
    currentMarkTarget = v.target.classList;
    menuShow.value = true;
};
const deleteMark = () => {
    // const val = v.target.classList;
    const val = currentMarkTarget;
    const els = document.getElementsByClassName(`${val}`);
    // const els = (document.getElementsByClassName(`${'mark_' + val}`));
    //.remove(`${'.mark_' + val}`);
    for (var i = 0; i < els.length; i++) {
        els[i].after(els[i].textContent);
    }
    for (var i = els.length - 1; i > -1; i--) {
        els[i].remove();
    }
    currentMarkTarget = '';
};

const highlightToAnswer = (n) => {
    const val = currentMarkTarget;
    const els = document.getElementsByClassName(`${val}`);
    // const els = (document.getElementsByClassName(`${'mark_' + val}`));
    //.remove(`${'.mark_' + val}`);
    let tmpText = '';
    for (var i = 0; i < els.length; i++) {
        if (els[i].parentElement.className === `${val}`) {
            // console.log(els[i]);
        } else {
            // console.log(els[i]);
            tmpText += els[i].textContent;
        }
    }
    emit('setInputAnswer', n, tmpText);
};

const test = (e) => {
    // console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
    // e.preventDefault();
    // alert('!!!!!!!!!!!!!!!!!!!!!!!!');
    // var newNode = document.createElement("strong");
    // newNode.setAttribute("class", "highlighted");
    // for (let node in range.commonAncestorContainer.childNodes) {
    // }
    // range.surroundContents(newNode);
    if (menuShow.value || !isPenMode.value || !isViewMode.value) {
        return false;
    }
    var range = document.getSelection().getRangeAt(0);
    if (range.startContainer === range.endContainer) {
        if (range.startOffset !== range.endOffset) {
            markId += 1;
            var highlightelement = document.createElement('mark');
            highlightelement.setAttribute('class', 'mark mark_' + markId);
            // highlightelement.addEventListener("click", function () {
            //     deleteMark(markId);
            // })
            // highlightelement.onclick = () => { deleteMark(markId); };
            range.surroundContents(highlightelement);
            addMarkEvent();
            document.getSelection().removeAllRanges();
        }
    } else {
        var allranges = getSafeRanges(range, document);
        var duCheck = false;
        for (var i = 0; i < allranges.length; i++) {
            if (!duCheck) {
                // if (allranges[i].commonAncestorContainer.innerHTML.indexOf('<mark') > -1 || allranges[i].commonAncestorContainer.innerHTML.indexOf('mark/>') > -1) {
                if (allranges[i].commonAncestorContainer.nodeName === 'MARK') {
                    duCheck = true;
                    break;
                }
            }
        }

        // if ((document.getSelection().getRangeAt(0)?.commonAncestorContainer.innerHTML).indexOf('<mark') > -1 || (document.getSelection().getRangeAt(0)?.commonAncestorContainer.innerHTML).indexOf('mark/>') > -1) {
        if (duCheck) {
            $q.notify({
                color: '#8E43F0',
                textColor: 'white',
                position: 'center',
                timeout: 2000,
                // icon: 'cloud_done',
                message: '하이라이트는 중복될 수 없습니다. 중복되는 하이라이트를 삭제해 주세요.',
            });
            document.getSelection().removeAllRanges();
        } else {
            markId += 1;
            for (var i = 0; i < allranges.length; i++) {
                var highlightelement = document.createElement('mark');
                highlightelement.setAttribute('class', 'mark_' + markId);
                // highlightelement.onclick = () => { deleteMark(markId); };
                // highlightelement.addEventListener("click", function () {
                //     deleteMark(markId);
                // })
                allranges[i].surroundContents(highlightelement);
                addMarkEvent();
                document.getSelection().removeAllRanges();
            }
        }
    }
    emit('isChangeHeader', true);
};

// var selection = window.getSelection();
// var ranges = selection.getRangeAt(0);
// var allranges = getSafeRanges(ranges, document);
// for (var i = 0; i < allranges.length; i++) {
//     allranges[i].surroundContents(highlightelement);
// }
const getRangeOfMiddleElements = (topStartNode, topEndNode) => {
    var rangeArray = new Array(0);
    for (var i = topStartNode.nextSibling; i != topEndNode; i = i.nextSibling) {
        rangeArray = rangeArray.concat(getRangeOfChildNodes(i));
    }
    return rangeArray;
};

const getRangeOfChildNodes = (node) => {
    var doc = document;
    var rangeArray = new Array(0);
    if (node.nodeType == Node.TEXT_NODE) {
        var xm = doc.createRange();
        xm.setStartBefore(node);
        xm.setEndAfter(node);
        rangeArray.push(xm);
    } else {
        for (var i = 0; i < node.childNodes.length; i++) {
            var childNode = node.childNodes[i];
            rangeArray = rangeArray.concat(getRangeOfChildNodes(childNode));
        }
    }
    return rangeArray;
};

const getSafeRanges = (range, currentDoc) => {
    var doc = currentDoc;
    var commonAncestorContainer = range.commonAncestorContainer;
    var startContainer = range.startContainer;
    var endContainer = range.endContainer;
    var startArray = new Array(0),
        startRange = new Array(0);
    var endArray = new Array(0),
        endRange = new Array(0);
    // @@@@@ If start container and end container is same
    if (startContainer == endContainer) {
        return [range];
    } else {
        for (var i = startContainer; i != commonAncestorContainer; i = i.parentNode) {
            startArray.push(i);
        }
        for (var i = endContainer; i != commonAncestorContainer; i = i.parentNode) {
            endArray.push(i);
        }
    }
    if (0 < startArray.length) {
        for (var i = 0; i < startArray.length; i++) {
            if (i) {
                var node = startArray[i - 1];
                while ((node = node.nextSibling) != null) {
                    startRange = startRange.concat(getRangeOfChildNodes(node));
                }
            } else {
                var xs = doc.createRange();
                var s = startArray[i];
                var offset = range.startOffset;
                var ea = startArray[i].nodeType == Node.TEXT_NODE ? startArray[i] : startArray[i].lastChild;
                xs.setStart(s, offset);
                xs.setEndAfter(ea);
                startRange.push(xs);
            }
        }
    }
    if (0 < endArray.length) {
        for (var i = 0; i < endArray.length; i++) {
            if (i) {
                var node = endArray[i - 1];
                while ((node = node.previousSibling) != null) {
                    endRange = endRange.concat(getRangeOfChildNodes(node));
                }
            } else {
                var xe = doc.createRange();
                var sb = endArray[i].nodeType == Node.TEXT_NODE ? endArray[i] : endArray[i].firstChild;
                var end = endArray[i];
                var offset = range.endOffset;
                xe.setStartBefore(sb);
                xe.setEnd(end, offset);
                endRange.unshift(xe);
            }
        }
    }
    var topStartNode = startArray[startArray.length - 1];
    var topEndNode = endArray[endArray.length - 1];
    var middleRange = getRangeOfMiddleElements(topStartNode, topEndNode);
    startRange = startRange.concat(middleRange);
    var response = startRange.concat(endRange);
    return response;
};
</script>

<style scoped lang="scss">
P {
    margin-bottom: 0;
    line-height: inherit;
}

.highlighted {
    ::-moz-selection {
        /* Code for Firefox */
        // color: red;
        background: yellow;
    }

    ::selection {
        // color: red;
        background: yellow;
    }

    ::v-deep mark {
        background-color: yellow;
        color: black;
    }
}

.highlighted-none {
    ::-moz-selection {
        /* Code for Firefox */
        // color: red;
        // background: yellow;
    }

    ::selection {
        // color: red;
        // background: white;
    }

    ::v-deep mark {
        background-color: white;
        color: black;
    }

    -webkit-touch-callout: none;
    touch-action: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.text-box :deep {
    div {
        -webkit-touch-callout: none;

        // font-size: size(16);
        img {
            position: relative;
            top: 4px;
        }

        p {
            //margin-bottom: 0px;
        }
    }
}

.text-box {
    -webkit-touch-callout: none;
    // border: 1px solid;
    // padding: 10px;
}

.disableTouch {
    // touch-action: none;
    // pointer-events: none;
}

/* .border-title_box_top {
  border: #3c5a86 1px solid;


  // display: inline-flex;
  .border-title {
    font-size: 16px;
    position: relative;
    margin: auto;
    top: -14px;
    // margin-left: -20px;
    display: inline;
    background-color: white;
  }
}

.border-title_box_left {
  border: #3c5a86 1px solid;

  display: inline-flex;

  .border-title {
    font-size: 16px;
    position: relative;
    margin: auto;
    top: -8px;
    margin-left: -20px;
    margin-right: 10px;
    display: inline;
    background-color: white;
    height: fit-content;
  }
}

.border-title_box_right {
  border: #3c5a86 1px solid;

  display: inline-flex;

  .border-title {
    font-size: 16px;
    position: relative;
    margin: auto;
    top: -8px;
    margin-left: 10px;
    margin-right: -20px;
    display: inline;
    background-color: white;
    height: fit-content;
  }
} */

::v-deep {
    .highlight {
        width: 3.5vw;
        margin-left: 2.5vmin;

        button {
            width: 3.5vw;
            height: 3.5vw;

            &:nth-of-type(n + 2) {
                margin-top: 2.5vmin;
            }

            .q-icon {
                font-size: 2.05vw;
            }
        }
    }

    .q-scrollarea__container {
        max-width: 1540px;
        margin: 0 auto;
    }

    .q-scrollarea__content {
        padding-bottom: 3.33vmin;
    }

    .q-scrollarea__bar--v,
    .q-scrollarea__thumb--v {
        width: 0.3vw;
    }
}

.passage {
    &__content {
        width: calc(100% - 40px);
        height: 100%;
        padding-right: 1vmin;
    }

    &__scroll {
        padding-right: 2.33vmin;
        // padding-bottom: 3.33vmin;
    }
}
</style>
